"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PointerVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _convert = require("../../convert");
var _remeda = require("remeda");
var _conditions = require("../../conditions");
var _types = require("../../types");
class PointerVariable {
  constructor() {
    (0, _defineProperty2.default)(this, "settings", PointerVariable.settings);
    (0, _defineProperty2.default)(this, "type", "pointer");
    (0, _defineProperty2.default)(this, "valueType", "value");
    (0, _defineProperty2.default)(this, "label", "Pointer");
    (0, _defineProperty2.default)(this, "description", "Use the value of another variable, and optionally convert the value.");
  }
  dependencies(params, resolver) {
    let value = params.ref ? _types.vals.value(resolver.resolve(params.ref)) : null;
    let deps = {
      value
    };
    if (params.convert) {
      deps.converter = (0, _convert.converterFromSpec)(resolver, {}, params.convert);
    }
    if (params.filter) {
      deps.filter = (0, _conditions.resolveConditionsForFilter)(params.filter, resolver);
    }
    deps.shift = !!params.shift;
    return deps;
  }
  getValue(ref, deps, batcher) {
    let {
      value,
      converter,
      filter,
      shift
    } = deps;
    let convertFunc = converter === null || converter === void 0 ? void 0 : converter.create(batcher);
    let write = res => {
      var _res;
      if (filter && Array.isArray(res)) {
        res = res.filter(it => (0, _conditions.testConditions)(filter, it));
      }
      if ((_res = res) !== null && _res !== void 0 && _res[0] && shift) {
        res = res[0];
      }
      ref.value = res;
    };
    if (convertFunc) {
      if ((0, _remeda.isPromise)(convertFunc)) {
        convertFunc.then(func => {
          write(func(value));
        });
      } else {
        write(convertFunc(value));
      }
    } else {
      write(value);
    }
  }
}
exports.PointerVariable = PointerVariable;
(0, _defineProperty2.default)(PointerVariable, "settings", {
  ref: {
    type: "var",
    title: "Reference",
    description: "Variable or constant to use.",
    variableType: "value",
    addToContext: true
  },
  convert: {
    type: "convert",
    title: "Conversion",
    description: "Conversion for the value."
  },
  filter: {
    type: "conditions",
    title: "Filter List",
    description: "If the value is a list, apply these conditions as a filter.",
    filter: true
  },
  shift: {
    type: "toggle",
    title: "Single Value",
    description: "If the value is a list, checking this will remove the list and use the first item on its own."
  }
});
//# sourceMappingURL=PointerVariable.js.map